
import {
  LayoutDashboard,
  BriefcaseIcon,
  Receipt,
  FileText,
  AlertTriangle,
  BarChart,
  TrendingUp,
  PieChart,
  Brain,
  ShieldCheck,
  Users,
  Settings,
} from "lucide-react";
import { NavigationConfig } from "../types";

export const lenderNavigation: NavigationConfig[] = [
  { name: "Dashboard", href: "/lender/dashboard", icon: LayoutDashboard },
  { 
    name: "Loan Management", 
    icon: BriefcaseIcon,
    children: [
      { name: "Active Loans", href: "/lender/loans/active", icon: Receipt },
      { name: "Applications", href: "/lender/loans/applications", icon: FileText },
      { name: "Risk Assessment", href: "/lender/loans/risk", icon: AlertTriangle },
    ]
  },
  { 
    name: "Analytics", 
    icon: BarChart,
    children: [
      { name: "Performance", href: "/lender/analytics/performance", icon: TrendingUp },
      { name: "Portfolio", href: "/lender/analytics/portfolio", icon: PieChart },
    ]
  },
  { 
    name: "AI Insights", 
    icon: Brain,
    children: [
      { name: "Risk Analysis", href: "/lender/ai/risk", icon: ShieldCheck },
      { name: "Market Trends", href: "/lender/ai/trends", icon: BarChart },
    ]
  },
  { name: "Borrowers", href: "/lender/borrowers", icon: Users },
  { name: "Settings", href: "/lender/settings", icon: Settings },
];
